// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .addressVerification__message {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    border: solid 1.5px #918f8f;
    color: #040404;
  }

  .warning-icon {
    display: none;
  }

  .addressVerification__input {
    display: flex;
  }

  .addressVerification {
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 0 ${(props) => props.theme.spacing.LAYOUT_SPACING.MED};
    }
  }

  .addressVerification__section {
    border-bottom: ${(props) => (!props.spc ? '1' : '0')}px solid;
    border-color: ${(props) => props.theme.colors.PRIMARY.GRAY};
  }

  .addressVerification__section--noBorder {
    border-bottom: none;
  }

  .addressVerification__title {
    font-family: ${(props) => props.theme.fonts.primaryFontFamily};
    font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
    text-transform: lowercase;

    &:first-letter {
      text-transform: uppercase;
    }
  }

  .addressVerification__suggest-lbl {
    font-family: ${(props) => props.theme.fonts.secondaryFontExtraBoldFamily};
    text-transform: lowercase;

    &:first-letter {
      text-transform: uppercase;
    }
  }

  .addressVerification__ctaContainer {
    text-align: center;
    margin: ${(props) => props.theme.spacing.LAYOUT_SPACING.MED}
      ${(props) => props.theme.spacing.LAYOUT_SPACING.XS}
      ${(props) => props.theme.spacing.LAYOUT_SPACING.XS};
    ${(props) =>
      props.spc
        ? `margin: ${props.theme.spacing.LAYOUT_SPACING.MED} 0px ${props.theme.spacing.LAYOUT_SPACING.MED} 0px;`
        : ''}
  }

  .addressVerification__cta {
    width: 100%;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
  }

  .addressVerification__cta-err {
    width: 100%;
    color: ${(props) => props.theme.colorPalette.red[500]};
    border: 0;
    background: ${(props) => props.theme.colorPalette.white};
    text-decoration: underline;

    &:hover {
      background: ${(props) => props.theme.colorPalette.white};
    }
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .TCPModal__Address div.TCPModal__InnerContent {
      top: 65%;
    }
  }
`;

export default styles;
